function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var e = /*#__PURE__*/function () {
  function e() {
    _classCallCheck(this, e);

    this.picker = void 0;
    this.options = void 0;
    this.priority = 0;
    this.dependencies = [];
  }

  _createClass(e, [{
    key: "attach",
    value: function attach(_e) {
      var _this = this;

      var t = this.getName(),
          s = _objectSpread({}, this.options);

      this.options = _objectSpread(_objectSpread({}, this.options), _e.options[t] || {});

      var _loop = function _loop() {
        var i = _Object$keys[_i];

        if (null !== s[i] && "object" == _typeof(s[i]) && Object.keys(s[i]).length && t in _e.options && i in _e.options[t]) {
          var n = _objectSpread({}, _e.options[t][i]);

          null !== n && "object" == _typeof(n) && Object.keys(n).length && Object.keys(n).every(function (_e2) {
            return Object.keys(s[i]).includes(_e2);
          }) && (_this.options[i] = _objectSpread(_objectSpread({}, s[i]), n));
        }
      };

      for (var _i = 0, _Object$keys = Object.keys(s); _i < _Object$keys.length; _i++) {
        _loop();
      }

      if (this.picker = _e, this.dependenciesNotFound()) {
        var _e9 = this.dependencies.filter(function (_e4) {
          return !_this.pluginsAsStringArray().includes(_e4);
        });

        return void console.warn("".concat(this.getName(), ": required dependencies (").concat(_e9.join(", "), ")."));
      }

      var i = this.camelCaseToKebab(this.getName());
      this.picker.ui.container.classList.add(i), this.onAttach();
    }
  }, {
    key: "detach",
    value: function detach() {
      var _e5 = this.camelCaseToKebab(this.getName());

      this.picker.ui.container.classList.remove(_e5), "function" == typeof this.onDetach && this.onDetach();
    }
  }, {
    key: "dependenciesNotFound",
    value: function dependenciesNotFound() {
      var _this2 = this;

      return this.dependencies.length && !this.dependencies.every(function (_e6) {
        return _this2.pluginsAsStringArray().includes(_e6);
      });
    }
  }, {
    key: "pluginsAsStringArray",
    value: function pluginsAsStringArray() {
      return this.picker.options.plugins.map(function (_e7) {
        return "function" == typeof _e7 ? new _e7().getName() : _e7;
      });
    }
  }, {
    key: "camelCaseToKebab",
    value: function camelCaseToKebab(_e8) {
      return _e8.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
    }
  }]);

  return e;
}();

export { e as BasePlugin };